import { CheckboxButtonGroupValue } from "../../../models/Button";
import CheckboxButtonGroup from "../../Control/Button/CheckboxButtonGroup";
import { ColumnLabel } from "../../Layout/ColumnLabel";

export type CostSelectorProps = {
    values: CheckboxButtonGroupValue<number>[],
    update: (values: CheckboxButtonGroupValue<number>[]) => void
}

export function CostSelector(props: CostSelectorProps) {
    return (
        <ColumnLabel label="Cost">
            <CheckboxButtonGroup
                classNames={{
                    container: "!grid-cols-6 lg:!grid-cols-11",
                    button: "min-h-[34px]"
                }}
                values={props.values}
                onClick={(clickedValue, buttonState) => props.update(buttonState)} />
        </ColumnLabel>
    )
}